<template>
  <Dialog class="dialog" ref="dialog" :title="title" :width="width" @closed="onClose">
    <template #default>
      <el-scrollbar class="modal-scroll">
        <el-form ref="mform" :model="form" :label-width="labelWidth" :rules="rules">
          <FormItem v-for="(c, i) in formCtrl" :key="'formItem' + i" :viewMode="c.viewMode || viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
        </el-form>
      </el-scrollbar>

      <div class="btns">
        <div class="mians">
          <el-button v-if="!viewMode" type="primary" @click="onSubmit('mform')">提 交</el-button>
          <el-button v-show="!viewMode" @click="hide" class="quxiao">
            取 消
          </el-button>
          <el-button v-show="viewMode" @click="hide" class="quxiao">
            返 回
          </el-button>
          <!-- <el-button @click="hide" class="quxiao">
            {{ viewMode ? '返 回' : '取 消' }}
          </el-button> -->
        </div>
      </div>
    </template>
  </Dialog>
</template>

<script>
export default {
  name: "FormDialog",
  props: {
    title: String,
    labelWidth: String,
    form: Object,
    formCtrl: Array,
    rules: Object,
    viewMode: Boolean,
    width: String,
  },
  data() {
    return {};
  },
  methods: {
    onChange({ key, value }) {
      console.log(key, value)
      this.$set(this.form, key, value)
      // this.$forceUpdate()
      // console.log('modal change', { ...this.form });
      this.$emit("onChange", {
        key,
        value,
      });
    },
    onSubmit() {
      // console.log({ ...this.form });
      // console.log({ ...this.rules })
      // console.log(this.$refs)
      this.$refs['mform'].validate((valid) => {
        // console.log(valid)
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(this.submitReq).catch(() => { });
        } else {
          console.log('验证不通过');
          console.log({ ...this.form })
          this.$message({
            type: 'error',
            message: '请修改错误信息',
          });
          return false;
        }
      });
    },
    submitReq() {
      this.$emit('onModalSubmit', this.form)
      this.hideDialog()
    },
    show() {
      this.$refs.dialog && this.$refs.dialog.show()
    },
    hide() {
      this.$refs.dialog && this.$refs.dialog.hide()
    },
    onClose() {
      if (this.$refs['mform']) {
        // console.log(this.$refs['mform'].resetFields)
        this.$refs['mform'].resetFields();
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-dialog {
  border-radius: 7px;
  overflow: hidden;

  .el-dialog__body {
    padding: 11px 20px 30px;
    box-sizing: border-box;
  }

  .modal-scroll {
    max-height: 600px;
    padding-bottom: 20px;

    .el-scrollbar__wrap {
      max-height: 600px;
      overflow-x: hidden;
      // min-height: 280px;
    }

    .is-horizontal {
      display: none;
    }
  }

  .el-form {
    margin: 16px 59px;
    padding-right: 50px;

    .view {
      margin-bottom: 10px;
    }

    .el-textarea__inner {
      font-family: "Microsoft Yahei";
    }

    .content {
      .el-input {
        width: 100%;
      }

      .el-select {
        width: 100%;
      }
    }
  }

  .btns {
    padding: 0;
    width: 100%;
    margin-top: 40px;

    .mians {
      display: flex;
      justify-content: center;

      .quxiao {
        background: #FFFFFF;
        color: #303133;
        border: 1px solid #DCDFE6;
      }
    }
  }

}
</style>
